// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"0f3865a9","278":"3d22a530","405":"c01986e2","488":"f2f58a21","596":"a079426d","748":"34af6335","841":"d9025da4","885":"4875420a"}[chunkId] + ".chunk.js";
};